<div class="cart-control-form-installation">
  <pdq-card variant="popover" color="white">
    <div class="card-title"><pdq-heading element="h5">Token for Shopify</pdq-heading></div>
    <pdq-divider></pdq-divider>
    <div class="card-content">
      <pdq-link
        label="View detailed installation instructions"
        [external]="true"
        url="https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components"></pdq-link>
      <pdq-input
        [disabled]="true"
        [formControl]="formGroup.get('usageToken')"
        label="Copy & paste this into Shopify's Components by 'Cart control token'"
        [clipboard]="true"></pdq-input>
      <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
    </div>
  </pdq-card>
</div>
